/**
 * @generated SignedSource<<72ecf850ccca524dc72aea8f7b9a0a5f>>
 * @relayHash 8bb49876281c293fe67e72ff8490da89
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bb49876281c293fe67e72ff8490da89

import { ConcreteRequest } from 'relay-runtime';
export type Ch_createInboundCallInput = {
  queryParameters: InboundCallQueryParametersInput;
  queryPath: string;
};
export type InboundCallQueryParametersInput = {
  callId?: string | null;
  callLine?: string | null;
  country?: string | null;
  lang?: string | null;
  phoneNumber?: string | null;
  pl?: string | null;
  record?: string | null;
};
export type useCallContextStoreChCreateInboundCallMutation$variables = {
  input: Ch_createInboundCallInput;
};
export type useCallContextStoreChCreateInboundCallMutation$data = {
  readonly ch_createInboundCall: {
    readonly createInboundCallOutput: {
      readonly inboundCallId: number;
    } | null;
  };
};
export type useCallContextStoreChCreateInboundCallMutation = {
  response: useCallContextStoreChCreateInboundCallMutation$data;
  variables: useCallContextStoreChCreateInboundCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_createInboundCallPayload",
    "kind": "LinkedField",
    "name": "ch_createInboundCall",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CreateInboundCallOutput",
        "kind": "LinkedField",
        "name": "createInboundCallOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inboundCallId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCallContextStoreChCreateInboundCallMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCallContextStoreChCreateInboundCallMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "8bb49876281c293fe67e72ff8490da89",
    "metadata": {},
    "name": "useCallContextStoreChCreateInboundCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "50ac859a92d653ab4c51cd9871c7c256";

export default node;
